module.exports = __webpack_public_path__ + "media/src/images/icons/flags/colombia-084f80f114c665bfd79600c463683b9e.svg";